import { benchmarkIsActive, benchmarkIncludedInWeightedWork } from '../../../../shared/models/benchmark-policy.model';
import { Component, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { Observable } from 'rxjs';

// client (demo services)
// import { HttpClient } from "../services/client"
import { DemoService } from '../../../../demo.service';


// interface (models)
// import { IUser } from "../services/interfaces"

import { FilterService, GridComponent, PageService, PdfExportService, SortService, ToolbarService } from '@syncfusion/ej2-angular-grids';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager  } from '@syncfusion/ej2-data';
import { FilterSettingsModel } from '@syncfusion/ej2-grids';

import {  IFilter } from '@syncfusion/ej2-angular-grids';
import {  ToolbarItems, GroupSettingsModel,
RowDataBoundEventArgs } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';

import { IFilterUI } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { HotToastService } from '@ngneat/hot-toast';
import { BsModalService } from 'ngx-bootstrap';
import { DataService } from './../../../../admin/system-log-manager/data.service';
import { Location } from '@angular/common';
import { GlobalFunctionsService } from './../../../../services/global-functions.service';

import { SystemLogTypeBenchmark } from 'src/app/shared/models/systemLogTypeBenchmark.model';


@Component({
  selector: 'app-log-type-benchmarks',
  templateUrl: './log-type-benchmarks.component.html',
  styleUrls: ['./log-type-benchmarks.component.scss']
})
export class LogTypeBenchmarksComponent implements OnInit {
  readonly benchmarkIsActive = benchmarkIsActive;
  readonly weightedIncluded = benchmarkIncludedInWeightedWork;
  system_log_type_benchmarks: any;
  search_model: SystemLogTypeBenchmark;



  
// public logs$: Observable<SystemLog[]>;
  // Normal Layout
  logs$: Observable<any>;
  logs: any;

  // for grid so it has change events.
  public data: Observable<DataStateChangeEventArgs>;
  public state: DataStateChangeEventArgs;
  @ViewChild('grid')
  public grid: GridComponent;
 
  public pageSettings: Object;
  public pageOptions = { pageSize: 100 }; 
  public filterOptions: FilterSettingsModel;
  public formatOptions: any;
  // public filterOptions: FilterSettingsModel;
  public filter : IFilter;
  public toolbarOptions: ToolbarItems[] | object;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;
  initialPage: { pageSize: number; };
  dateFormat: string;




     job_types: any;
     job_types_tree: any;
      jobTypesTreeObject: { dataSource: any; id: string; parentID: string; text: string; hasChildren: string; };


 
  job_type_locations: Object;
  job_type_courts: Object;
  job_type_document_types: Object;
  job_type_affidavit_types: Object;
  collection: any;
  addTypeClick: boolean;
  updateTypeClick: boolean;
  initialCount = 0; // Put this in the master -> for child component
  public count;
  currentUserVAR: any;
  sessionUserName: any;
  sessionUserId: any;
  sessionBrandId: any;
  nav: any;
  modalRef: any;
  system_log_types: any;
  get_latest_system_log_type_id: Object;
  system_log_type_data_sector_types: Object;
  get_latest_log_type_data_sector_type_id: Object;
  get_latest_log_type_benchmark_id: Object;
  user_levels: any;



  constructor(

    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     private modalService: BsModalService, viewRef: ViewContainerRef,
     private _location: Location,  public gfunc: GlobalFunctionsService
  ) { }

  ngOnInit(): void {



// Setup Grid
this.toolbarOptions = ['Search'];
// this.toolbarOptions = ['ExcelExport', 'Search'];
// this.toolbar = [
// { text: 'Agent Update Request', tooltipText: 'Click', prefixIcon: 'e-expand', id: 'Click' }];

//  this.initialPage = { pageSize: 100 };
this.filterOptions = {
  type: 'Menu'
};
this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
this.formatOptions = { type: 'date', format: 'dd/MM/yyyy' };
this.dateFormat = 'dd/MM/yyyy hh:mm a';
this.filter = { params: { format: this.dateFormat } };
this.groupOptions = { columns: ['log_type_name'] };

    this.search_model = new SystemLogTypeBenchmark
    this.search_model ={
    }

    this.getSystemLogTypeBenchmarks(this.search_model)
    this.getFormUserLevels()
    this.getSystemLogTypes()
  }



  getSystemLogTypeBenchmarks(model) {
    this._demoService.getSystemLogTypeBenchmarks(model).subscribe(
       data => { this.system_log_type_benchmarks = data;  },
       err => console.error(err),
        () => {
          console.log('done loading System Log Type Benchmarks')
         // this.collection = Array (this.job_types, this.job_type_locations); // collection of all data
         // let mappedJSON = JSON.parse(mapped);
         // console.log('Mapped JSON Array: ' + mappedJSON);
        }
          );
   }
  




// nSome grid functions

toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}


clickHandler(args: ClickEventArgs): void {
  if (args.item.id === 'Click') {

  //  this.grid.showSpinner();

  //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
 //  console.log(args.data.items);
 


  let pdfdata;
  const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
  for (let i = 0; i < query.queries.length; i++) {
    if (query.queries[i].fn === 'onPage') {
      query.queries.splice(i, 1);       // remove page query to get all records
      break;
    }
  }
  const fdata = new DataManager({ json: this.logs }).executeQuery(query).then((e: any) => {
    pdfdata = e.result as object[];  // get all filtered records
    const exportProperties = {
      dataSource: pdfdata,
    };
    // console.log(pdfdata.results);
    
   // this.search_results = pdfdata.records; // need this if a grouping is set.
/*     this.search_results = pdfdata;
    this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
    this.toastr.success( "Press Start To Process Que");  */
   // this.grid.pdfExport(exportProperties);
  }).catch((e) => true);
  }

 //  this.grid.hideSpinner();

}



 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true };
  this.modalRef = this.modalService.show(template, config);
}

// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
  this.modalRef.hide();
  this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
};


refreshGrid() { // refresh the databutton
  // this.getFiles();
  // this.getSystemLogTypes();
  this.getSystemLogTypeBenchmarks(this.search_model);
  this.grid.refresh();
};
   // to router navigate back
   public goBack() {
    this._location.back();
    }



    makeDuplicateSystemLogTypeBenchmark(model){
      if (confirm('We are about duplicate this Log Type Benchmark, Are you Sure this also needs to be hard coded into system to function... please see developer first!!!!?')) {
      // post a new With this model. & Name as copuy
      model.log_type_benchmark_name =  model.log_type_benchmark_name + '_COPY'
      model.log_type_benchmark_description = '_COPY **** of **** ' + model.log_type_benchmark_description
      model.notes = '_COPY **** of **** ' + model.notes
      model.is_active = '';
      model.created_tested = '';
      model.log_type_benchmark_colour =  model.log_type_benchmark_colour
      model.log_type_benchmark_icon =  model.log_type_benchmark_icon
      model.log_type_id =  model.log_type_id
      model.user_level = model.user_level


      // log_type_id?: number
   
      
      //  user_level?: number;
      //  brand_type_id?: number;
      //  unit_per_day?: number;
      //  unit_dollar_cost?: number;
      //  unit_dollar_value?: number;
      //  unit_time_duration_ms?: number;
      //  unit_per_day_tolerance_percentage?: number;


      // model.doc_notes = '_COPY **** of **** ' + model.doc_notes
      // model.is_active = '';
      // model.templates_created_tested = '';
      this.createSystemLogTypeBenchmark(model);
      }
    }
    


    deleteSystemLogTypeBenchmark(log_type_benchmark_id) {
      if (confirm('Are you sure you want to delete ' + '?... This cannot be undone!')) {
        this._demoService.deleteSystemLogTypeBenchmark(log_type_benchmark_id).subscribe(
           data => {
             // refresh the list
             this.toastr.warning("Data Object Deleted!")
             this.refreshGrid();
             return true;
           },
           error => {
             console.error('Error deleting!');
            return console.log(error);
           }
        );
    }
    };
    



    getFormUserLevels() {
      this._demoService.getFormUserLevels().subscribe(
         data2 => { this.user_levels = data2;
          console.log(data2);
       },
         err => console.error(err),
         () => console.log('done loading User Levels')
       );
     }
  
  
     getSystemLogTypes() {
      this._demoService.getSystemLogTypes().subscribe(
         data2 => { this.system_log_types = data2;
          // console.log(data2);
       },
         err => console.error(err),
         () => console.log('done loading User Levels')
       );
     }



// for duplication function
    createSystemLogTypeBenchmark(model) {
      // console.log(model);
          this._demoService.createSystemLogTypeBenchmark(model).subscribe(
               data => {  this.get_latest_log_type_benchmark_id = data; // this is the retuned json upon creation.
            
                this.toastr.success('Log Type Benchmark Created');
       
              //  this.closeParentModel.emit();
        
               this.gfunc.globalViewSystemLogTypeBenchmarksSkipRoute();
     
     
               // CreateJobTypeComponent.returned.next(false);
                 //  return true;
               },
               error => {
                 this.toastr.error('Adding Type Benchmark Failed :: Please try again!');
                 // console.log(Observable.throw(error));
                 // return Observable.throw(error);
               }
          );
          }


}
